import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=78a88fe4&scoped=true"
import script from "./TableHeader.vue?vue&type=script&lang=js"
export * from "./TableHeader.vue?vue&type=script&lang=js"
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=78a88fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a88fe4",
  null
  
)

export default component.exports